<template>
    <div>
        <sample-header></sample-header>
        <coupon-status :code="code"></coupon-status>
        <sample-footer></sample-footer>
    </div>
</template>
<script>
import SampleHeader from "@/components/layout/SampleHeader";
import SampleFooter from "@/components/layout/SampleFooter";
const CouponStatus = () => import("@/components/status/CouponStatus");
export default {
  props: ["code"],
  components: { SampleHeader, SampleFooter, CouponStatus }
};
</script>
<style>
</style>
